import { Reducer, useEffect, useReducer } from 'react';
import {
  InspectionTripletFilters,
  InspectionChart,
} from 'shared/types/analytics';
import { extractFiltersValues } from 'charts/common/filterValues';
import { useInspectionChartDependencies } from 'charts/common/useInspectionChartDependencies';
import { isEmptyArray } from 'shared/utils/array';
import { createFiltersForView } from './createFilters';
import { useChartFiltersPersistence } from '../common/useChartFiltersPersistence';
import { defaultValues } from './defaultFilters';
import { filtersReducer } from 'charts/common/filtersReducer';
import { FilterAction } from './types';
import { useFiltersActions } from 'charts/common/filtersActions';

export function useInspectionTripletFilters():
  | InspectionTripletFilters
  | undefined {


  const [filters, dispatchFilters] = useReducer<
    Reducer<InspectionTripletFilters | undefined, FilterAction>
  >(filtersReducer, undefined);
  const { rewriteFilters, ...filtersActions } =
    useFiltersActions(dispatchFilters);

  const { savedFilters } = useChartFiltersPersistence(InspectionChart.inspectionTriplet, filters, defaultValues);

  const dependencies = useInspectionChartDependencies(savedFilters);

  useEffect(() => {
    if (!dependencies || isEmptyArray(dependencies.processes)) return;

    const filterValues = extractFiltersValues(filters) ?? dependencies.filters;
    rewriteFilters(createFiltersForView({ ...dependencies, filters: filterValues }, filtersActions));
  }, [dependencies, rewriteFilters]);

  return filters;
}
